(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["club-notice-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.clubNoticeProductSwatches) {
    window.clubNoticeProductSwatches = true;
    document.addEventListener('click', function (event) {
      const swatch = event.target.closest('.cn-products__swatch');
      if (!swatch) return;

      const card = swatch.closest('.cn-products__card');
      if (!card) return;

      const track = card.querySelector('.cn-swipe-track');
      const image = card.querySelector('.cn-products__image');
      if (image && swatch.dataset.cnImage) {
        image.src = swatch.dataset.cnImage;
        if (swatch.dataset.cnSrcset) image.srcset = swatch.dataset.cnSrcset;
      }
      if (track) {
        // Rebuild the extra (lifestyle/back) slides so they match the newly selected color
        // instead of leaving the previous color's photos in place.
        const extraSlides = track.querySelectorAll('.cn-swipe-slide--photo');
        extraSlides.forEach(function (slide) { slide.remove(); });
        const extraUrls = (swatch.dataset.cnExtraImages || '').split(',').filter(Boolean);
        extraUrls.forEach(function (url) {
          const slide = document.createElement('div');
          slide.className = 'cn-swipe-slide cn-swipe-slide--photo';
          const img = document.createElement('img');
          img.src = url;
          img.loading = 'lazy';
          img.className = 'cn-products__image cn-products__image--photo';
          slide.appendChild(img);
          track.appendChild(slide);
        });

        const gallery = card.querySelector('.cn-swipe-gallery');
        const existingDots = gallery ? gallery.querySelector('.cn-swipe-dots') : null;
        if (existingDots) existingDots.remove();
        const totalSlides = 1 + extraUrls.length;
        if (gallery && totalSlides > 1) {
          const dots = document.createElement('div');
          dots.className = 'cn-swipe-dots';
          for (let i = 0; i < totalSlides; i++) {
            const dot = document.createElement('span');
            dot.className = 'cn-swipe-dot' + (i === 0 ? ' is-active' : '');
            dots.appendChild(dot);
          }
          gallery.appendChild(dots);
        }
        const prevArrow = gallery ? gallery.querySelector('.cn-swipe-arrow--prev') : null;
        const nextArrow = gallery ? gallery.querySelector('.cn-swipe-arrow--next') : null;
        if (prevArrow) prevArrow.hidden = true;
        if (nextArrow) nextArrow.hidden = totalSlides < 2;

        track.scrollTo({ left: 0 });
      }

      card.querySelectorAll('.cn-products__swatch').forEach(function (item) {
        const active = item === swatch;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (swatch.dataset.cnUrl) {
        card.querySelectorAll('.cn-products__product-link, .cn-products__title-link, .cn-products__quick-add').forEach(function (link) {
          link.href = swatch.dataset.cnUrl;
        });
      }

      const price = card.querySelector('.cn-products__price');
      if (price && swatch.dataset.cnPrice) price.textContent = swatch.dataset.cnPrice;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
